import React, { StrictMode } from "react";
import { createRoot } from 'react-dom/client';

import "./design.scss"
import Tttpopup from './components/tttpopup';
import Tttbutton from "./components/tttbutton";
import usePopupStore from "./store/global";

const root = createRoot(document.getElementById('texttotext'))
root.render(<StrictMode><Tttpopup /></StrictMode>)

const Texttotextbutton = (props) => {
    var node = document.getElementById('texttotext-annotation-btn')
    if (node == null) {
        node = document.getElementById('webviewer-1').contentWindow.document.getElementById('texttotext-annotation-btn')
    }
    const root = createRoot(node)
    root.render(<Tttbutton {...props} />);
}


window.tttbutton = Texttotextbutton;
